var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashBin2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49316 6.29785C7.90738 6.29785 8.24316 6.63364 8.24316 7.04785V10.8099C8.24316 11.2241 7.90738 11.5599 7.49316 11.5599C7.07895 11.5599 6.74316 11.2241 6.74316 10.8099V7.04785C6.74316 6.63364 7.07895 6.29785 7.49316 6.29785Z",
    fill: "#173348"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22075 7.04785C5.22075 6.63364 4.88496 6.29785 4.47075 6.29785C4.05653 6.29785 3.72075 6.63364 3.72075 7.04785V10.8099C3.72075 11.2241 4.05653 11.5599 4.47075 11.5599C4.88496 11.5599 5.22075 11.2241 5.22075 10.8099L5.22075 7.04785Z",
    fill: "#173348"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 1C4 0.447715 4.44772 0 5 0H7C7.55228 0 8 0.447715 8 1H9.5C10.6046 1 11.5 1.89543 11.5 3V4.5C11.5 4.87014 11.2989 5.19331 11 5.36622V11.5C11 12.8807 9.88071 14 8.5 14H3.5C2.11929 14 1 12.8807 1 11.5V5.36622C0.701099 5.19331 0.5 4.87014 0.5 4.5V3C0.5 1.89543 1.39543 1 2.5 1H4ZM2 4H10V3C10 2.72386 9.77614 2.5 9.5 2.5H2.5C2.22386 2.5 2 2.72386 2 3V4ZM2.5 5.5V11.5C2.5 12.0523 2.94772 12.5 3.5 12.5H8.5C9.05228 12.5 9.5 12.0523 9.5 11.5V5.5H2.5Z",
    fill: "#173348"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBin2);
export default __webpack_public_path__ + "static/media/trashBin2.0d34ed63f407a114f8be28bf3ba8361c.svg";
export { ForwardRef as ReactComponent };